import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

import { HandleDriversScreen, DriverUpdate } from '../screens/drivers';

const DriversRouter: FC = () => (
    <Routes>
        <Route path="/" element={<HandleDriversScreen />} />
        <Route path=":id" element={<DriverUpdate />} />
    </Routes>
);

export { DriversRouter };
